<template>
  <div>
    <v-container>
    <v-row>
      <v-col
        cols="12"
        :md="!view?12:8"
      >
        <base-material-card icon="mdi-account-outline" :short="short">
          <template v-slot:after-heading>
            <div class="title font-weight-light" v-if="!short">
              <span class="body-1">Транспортное средство - </span>
              <v-spacer />
              <span class="body-2">{{ title }}
                <v-icon
                  v-if="view && form.id!=null"
                  @click="view = false, change = true"
                >mdi-pencil</v-icon>
                <v-icon
                  v-if="change && form.id!=null"
                  @click="view = true, change= false"
                >mdi-eye</v-icon>
              </span>
            </div>
          </template>

          <form>
            <base-material-tabs
              v-model="tab"
              color="warning"
            >
              <v-tab>Транспортное средство</v-tab>
              <v-tab v-if="!short">Страхование</v-tab>
              <v-tab v-if="!short">Собственник</v-tab>
              <v-tab v-if="!short">Водитель</v-tab>
              <v-tab-item>
                <v-row>
                  <v-col
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.model"
                      :disabled="view"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      color="secondary"
                      label="Марка транспортного средства"
                      prepend-icon="mdi-car"
                      type="text"
                      @input="()=>form.model = form.model.toUpperCase()"
                    />
                  </v-col>
                  <v-col
                    v-if="!form.without_vin"
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.vin"
                      :disabled="view"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]{17}$/.test(v) || 'VIN должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="VIN"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      @input="()=>form.vin = form.vin.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col
                    v-if="form.without_vin"
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.body"
                      :disabled="view"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]+$/.test(v) || 'Номер кузова должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="Номер кузова"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      @input="()=>form.body = form.body.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="form.without_vin"
                      :disabled="view"
                      color="secondary"
                      label="VIN отсутствует"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field

                      v-model="form.number"
                      :disabled="form.without_number || view"
                      color="secondary"
                      label="Госномер"
                      prepend-icon="mdi-barcode-scan"
                      @input="()=>form.number = form.number.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="form.without_number"
                      color="secondary"
                      label="Отсутствует"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="form.date"
                      :disabled="view"
                      required
                      color="secondary"
                      type="number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      label="Год выпуска ТС"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model="form.doc_type"
                      :disabled="view"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      :items="dict.doc_type"
                      color="secondary"
                      label="Тип документа"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.doc.series"
                      :disabled="view"
                      required
                      :counter="4"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение!']"
                      color="secondary"
                      label="Серия документа"
                      prepend-icon="mdi-file-document-box"
                      maxlength="4"
                      @input="()=>form.doc.series = form.doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.doc.number"
                      :disabled="view"
                      required
                      :counter="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Номер документа"
                      maxlength="6"
                      @input="()=>form.doc.number = form.doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.doc.date"
                      :disabled="view"
                      type="date"
                      label="Дата выдачи"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-if="!short">
                <v-row dense>
                  <v-col cols="12">
                    Страховые полиса
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <v-select
                      v-model="selected.insurance"
                      :disabled="view"
                      :items="select.insurance"
                      label="Выберите полис"
                      item-text="name"
                      item-value="id"
                      @change="info.insurance = select.insurance.filter(a=>a.id == selected.insurance)[0]"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-btn
                      :disabled="view || !selected.insurance"
                      color="primary"
                      min-width="150"
                      @click="form.insurances.push(info.insurance), selected.insurance = null"
                    >
                      Добавить
                    </v-btn>
                  </v-col>
                  <v-col cols="3">
                    <v-btn
                      v-if="$store.state.user.role !=3"
                      :disabled="view"
                      min-width="150"
                      color="secondary"
                      @click="show_insurance_create_dialog"
                    >
                      Создать
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <v-data-table
                      :headers="table.insurance.headers"
                      :items="form.insurances"
                      @click:row="(item)=>info.insurance = item"
                    >
                      <template v-slot:item.actions="{item}">
                        <v-icon
                          :disabled="view"
                          @click="show_insurance_show_dialog(item)"
                        >
                          mdi-cog
                        </v-icon>
                        <v-icon
                          :disabled="view"
                          @click="form.insurances = form.insurances.filter(a=>a!=item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <template v-slot:item.insurer="{item}">
                        {{ item.insurer_text }}<br>
                        {{ item.doc.series }} {{ item.doc.number }}
                      </template>
                      <template v-slot:item.driver="{item}">
                        <div v-if="item.driver_item">
                          {{ item.driver_item.surname }} {{ item.driver_item.name }} {{ item.driver_item.patronymic }}<br>
                          {{ item.driver_item.phone }}
                        </div>
                      </template>
                      <template v-slot:item.vehicle="{item}">
                        <div v-if="item.vehicle_item">
                          {{ item.vehicle_item.model }} {{ item.vehicle_item.number }}<br>
                          {{ item.vehicle_item.vin }}
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="info.insurance.insurer"
                      readonly
                      :items="select.insurer"
                      color="secondary"
                      label="Страховая"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="info.insurance.doc.series"
                      readonly
                      color="secondary"
                      label="Серия"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{3}$/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-car"
                      :counter="3"
                      maxlength="3"
                      :disabled="view"
                      @input="()=>info.insurance.doc.series = info.insurance.doc.series.toUpperCase().substring(0,3)"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="info.insurance.doc.number"
                      readonly
                      color="secondary"
                      label="Номер полиса"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{10}$/.test(v) || 'Неверное значение']"
                      :counter="10"
                      maxlength="10"
                      :disabled="view"
                      @input="()=>info.insurance.doc.number = info.insurance.doc.number.toUpperCase().substring(0,10)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="info.insurance.doc.date"
                      readonly
                      color="secondary"
                      type="date"
                      label="Срок действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="info.insurance.kasko"
                      readonly
                      color="secondary"
                      label="КАСКО"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="!short">
                <v-row>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.owner"
                      editable
                      :filter="name_filter"
                      :items="select.clients"
                      item-value="id"
                      label="Выберите собственника"
                      :disabled="view"
                      @change="owner_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.birthday }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      color="primary"
                      class="ma-3"
                      min-width="100"
                      @click="show_client_create_dialog"
                    >
                      Добавить
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="ma-3"
                      min-width="100"
                      @click="show_client_show_dialog(form.owner_item)"
                    >
                      Открыть
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.owner_item.surname"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Фамилия"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.owner_item.surname=form.owner_item.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.owner_item.name"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Имя"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.owner_item.name=form.owner_item.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.owner_item.patronymic"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Отчество"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.owner_item.patronymic=form.owner_item.patronymic.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.owner_item.address"
                      v-validate="'required'"
                      name="first_driver_address"
                      readonly
                      color="secondary"
                      label="Адрес"
                      prepend-icon="mdi-home"
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.owner_item.birthday"
                      readonly
                      color="secondary"
                      label="Дата рождения"
                      type="date"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-if="!short">
                <v-row>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.driver"
                      editable
                      :filter="name_filter"
                      :items="select.clients"
                      item-value="id"
                      label="Выберите водителя"
                      :disabled="view"
                      @change="driver_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.birthday }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      color="primary"
                      class="ma-3"
                      min-width="100"
                      @click="show_client_create_dialog"
                    >
                      Добавить
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="ma-3"
                      min-width="100"
                      @click="show_client_show_dialog(form.driver_item)"
                    >
                      Открыть
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.driver_item.surname"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Фамилия"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.driver_item.surname=form.driver_item.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.driver_item.name"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Имя"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.driver_item.name=form.driver_item.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.driver_item.patronymic"
                      v-validate="'required'"
                      readonly
                      color="secondary"
                      label="Отчество"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.driver_item.patronymic=form.driver_item.patronymic.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.driver_item.address"
                      v-validate="'required'"
                      name="first_driver_address"
                      readonly
                      color="secondary"
                      label="Адрес"
                      prepend-icon="mdi-home"
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.driver_item.birthday"
                      readonly
                      color="secondary"
                      label="Дата рождения"
                      type="date"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </base-material-tabs>
          </form>
          <v-card-actions v-if="!short">
            <v-btn
              :disabled="loader.show"
              color="secondary"
              min-width="250"
              @click="show? $emit('close') :$router.push('/vehicle/list')"
            >
              Назад
            </v-btn>
            <v-btn
              v-if="!view"
              :disabled="loader.show"
              color="primary"
              min-width="250"
              @click="vehicle_save"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
      <v-col
        v-if="view"
        cols="12"
        md="4"
      >
        <base-material-card
          class="v-card-profile"
          title="События"
        >
          <v-card-text>
            <div
              v-for="(item,index) in events"
              :key="index"
              style="cursor: pointer"
            >
              <event-form
                v-if="index == active"
                :create="false"
                :view="false"
                :change="true"
                :data="item"
                :show="true"
                :short="true"
                @close="load_events()"
              />
              <v-row v-else  @click="active = index" class="select_row">
                <v-col cols="2">
                  <v-icon large :color="item.color">{{ $store.state.dict.events[item.type].icon }}</v-icon>
                </v-col>
                <v-col cols="4">
                  <font :color="item.color">{{ $store.state.dict.events[item.type].name }} {{ item.start }}<br></font>
                  <font color="#db7093"><span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span><br></font>
                  <b>{{dict.state[item.state]}}</b>
                  
                </v-col>
                <v-col cols="6">
                  <font color="blue">{{item.text}}</font>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              min-width="100"
              @click="showCreateEvent"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
        <base-material-card
          color="success"
          class="v-card-profile"
          title="Комментарии"
        >
          <v-card-text>
            <v-data-table
              :items="comments"
              :headers="headers.comment"
              hide-default-header
              :footerProps="datatable_footer"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
              </template>
              <template v-slot:item.created="{item}">
                {{item.created}}<br>
                <font color="#db7093">{{item.creator_name}}</font>
              </template>
              <template v-slot:item.text="{item}">
                <font color="blue">{{item.text}}</font>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="comment"
                  label="Введите комментарий"
                />
              </v-col>
              <v-col cols="4">
                <v-btn
                  :disabled="!comment || comment.length == 0"
                  color="primary"
                  @click="create_comment"
                >
                  <span class="mx-5">Добавить</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>

      <v-dialog
        v-model="dialog.event.show"
        scrollable
        persistent
      >
        <event-form
          :create="dialog.event.create"
          :view="dialog.event.view"
          :change="dialog.event.change"
          :data="dialog.event.data"
          :show="dialog.event.show"
          @close="dialog.event.show = false, load_events()"
        />
      </v-dialog>
      <v-dialog v-model="dialog.client.show" persistent>
        <clients-form
          :create="dialog.client.create"
          :view="dialog.client.view"
          :change="dialog.client.change"
          :item="dialog.client.data"
          @create="create_client"
          @close="client_close"
        />
      </v-dialog>
      <v-dialog v-model="dialog.insurance.show" persistent>
        <InsuranceForm
          :create="dialog.insurance.create"
          :view="dialog.insurance.view"
          :change="dialog.insurance.change"
          :show="dialog.insurance.show"
          :data="dialog.insurance.data"
          @close="insurance_close"
        />
      </v-dialog>
    </v-row>
    </v-container>
  </div>
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  import EventForm from './EventForm'
  export default {
    name: 'VehicleForm',
    components: { EventForm },
    props: ['create', 'view', 'change', 'show', 'data', 'short'],
    data () {
      return {
        tab: 0,
        loader: {
          show: false,
        },
        title: '',
        form: {
          id: '',
          insurer: 0,
          doc: {
            series: '',
            number: '',
            date: '',
          },
          vehicle: '',
          vehicle_item: { doc: {} },
          driver_item: { driver_doc: {} },
          owner_item: { driver_doc: {} },
          insurances: [],
        },
        select: {
          insurer: [],
        },
        info: {
          insurance: { doc: {} },
        },
        dialog: {
          event: {
            show: false,
            item: {},
          },

          client: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
          insurance: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
        },
        comment: '',
        comments: [],
        headers: {
          comment: [
            {
              value: 'created'
            },
            {
              value: 'text'
            }
          ]
        },
        table: {
          insurance: {
            headers: [
              {
                text: 'Страхователь',
                value: 'insurer',
              },
              {
                text: 'Срок действия',
                value: 'doc.date_text',
              },
              {
                text: 'Водитель',
                value: 'driver',
              },
              {
                text: 'Автомобиль',
                value: 'vehicle',
              },
              {
                text: 'Действие',
                value: 'actions',
              }],
          },
        },
        events: [

        ],
        select: {
          clients: [],
          state: [
            { value: 1, text: 'Новый' },
            { value: 2, text: 'Завершен' },
            { value: 3, text: 'Отменен' },
          ],
          type: [],
          insurer: [],
          insurance: [],
        },
        selected: {
          insurance: null,
        },
        dict: {
          state: {
            1: 'Новый',
            2: 'Завершен',
            3: 'Отменен',
          },
          doc_type: [
            { value: 1, text: 'Свидетельство о регистрации ТС' },
            { value: 2, text: 'Паспорт ТС' },
            { value: 3, text: 'Паспорт самоходной машины' },
            { value: 4, text: 'Аналогичный документ' },
          ],
        },
      }
    },
    watch: {
      show: function () {
        if (this.show) {
          if (this.create) this.title = 'Создание'
          if (this.change) this.title = 'Изменение'
          if (this.view) this.title = 'Просмотр'
          this.load()
        }
      },
    },
    mounted: function () {
      for (let x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.select.insurer.push({
          value: Number(x),
          text: this.$store.state.dict.insurer[x].name,
        })
      }
      this.load_clients()
      this.load_insurances()
    },
    methods: {
      
      insurance_close: function (data) {
        this.dialog.insurance.show = false
        console.log(data)
        if (data) {
          data.insurer_text = this.$store.state.dict.insurer[data.insurer].name

          if (data.kasko) data.kasko_text = 'Есть'
          else data.kasko_text = 'Нет'
          data.doc.date_text = moment(data.doc.date).format('DD.MM.YYYY')
          data.doc.date = moment(data.doc.date).format('YYYY-MM-DD')
          data.name = data.insurer_text + ', ' + data.doc.date_text
          this.select.insurance.push(data)
          this.selected.insurance = data.id
          this.info.insurance = data
        }
      },
      show_insurance_show_dialog: function (data) {
        this.dialog.insurance.data = data
        this.dialog.insurance.create = false
        this.dialog.insurance.change = false
        this.dialog.insurance.view = true
        this.dialog.insurance.show = true
      },
      show_insurance_create_dialog: function () {
        this.dialog.insurance.data = null
        this.dialog.insurance.create = true
        this.dialog.insurance.change = false
        this.dialog.insurance.view = false
        this.dialog.insurance.show = true
      },
      load_insurances: function () {
        this.axios.post('/api/common/insurance/list', {})
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].insurer_text = this.$store.state.dict.insurer[result.data.data[x].insurer].name

                if (result.data.data[x].kasko) result.data.data[x].kasko_text = 'Есть'
                else result.data.data[x].kasko_text = 'Нет'
                result.data.data[x].doc.date_text = moment(result.data.data[x].doc.date).format('DD.MM.YYYY')
                result.data.data[x].doc.date = moment(result.data.data[x].doc.date).format('YYYY-MM-DD')
                result.data.data[x].name = result.data.data[x].insurer_text + ', ' + result.data.data[x].doc.date_text
              }
              this.select.insurance = result.data.data
            }
          })
          .catch(e => {

          })
      },
      load_clients: function () {
        this.axios.post('/api/clients/list', this.form)
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].birthday = moment(result.data.data[x].birthday).format('YYYY-MM-DD')
              }
              this.select.clients = result.data.data
            }
          })
          .catch(e => {

          })
        this.load()
      },
      create_client: function (data) {
        this.axios.post('/api/clients/create/', data)
          .then(response => {
            if (!response.data.error) {
              this.dialog.client.show = false
              this.$store.commit('snackbar', 'Успешно')
              this.select.clients.push(response.data.data)
              if (this.tab == 2) {
                this.form.owner_item = response.data.data
              }
              if (this.tab == 3) {
                this.form.driver_item = response.data.data
              }
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
      client_close: function () {
        this.dialog.client.show = false
        this.load_clients()
      },
      show_client_create_dialog: function () {
        this.dialog.client.create = true
        this.dialog.client.change = false
        this.dialog.client.view = false
        this.dialog.client.show = true
      },
      show_client_show_dialog: function (data) {
        console.log(data)
        this.dialog.client.create = false
        this.dialog.client.change = false
        this.dialog.client.view = true
        this.dialog.client.show = true
        this.dialog.client.data = data
      },
      owner_changed: function (item) {
        this.form.owner_item = this.select.clients.filter(a => a.id == item)[0]
      },
      driver_changed: function (item) {
        this.form.driver_item = this.select.clients.filter(a => a.id == item)[0]
      },
      name_filter: function (item, query, text) {
        if ((item.surname + ' ' + item.name + ' ' + item.patronymic).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load: function () {
        if (this.change || this.view) {
          if (!this.data) {
            this.$axios.post('/api/common/vehicle/list/', { id: this.$route.params.id })
              .then(response => {
                if (!response.data.error) {
                  this.form = response.data.data[0]
                  this.form.doc = this.form.doc || {}
                  this.form.doc.date = moment(this.form.doc.date).format('YYYY-MM-DD')
                  this.form.driver_item = this.form.driver_item || { driver_doc: {} }
                  this.form.driver_item.driver_doc.date = moment(this.form.driver_item.driver_doc.date).format('YYYY-MM-DD')

                  this.form.owner_item = this.form.owner_item || { driver_doc: {} }
                  this.form.owner_item.driver_doc.date = moment(this.form.owner_item.driver_doc.date).format('YYYY-MM-DD')
                  this.form.insurances = this.form.insurances || []
                  for (let x in this.form.insurances) {
                    this.form.insurances[x].doc.date = moment(this.form.insurances[x].doc.date).format('YYYY-MM-DD')
                    this.form.insurances[x].doc.date_text = moment(this.form.insurances[x].doc.date).format('DD.MM.YYYY')
                  }
                } else {
                  this.$store.commit('snackbar', response.data.error || 'Ошибка при получении данных')
                }
              })
              .catch(e => {
                console.log(e)
                this.$store.commit('snackbar', 'Ошибка при получении данных')
              })
          } else {
            this.form = JSON.parse(JSON.stringify(this.data))
            this.form.doc = this.form.doc || {}
                  this.form.doc.date = moment(this.form.doc.date).format('YYYY-MM-DD')
                  this.form.driver_item = this.form.driver_item || this.select.clients.filter(a=>a.id == this.form.driver)[0]|| { driver_doc: {} }
                  this.form.driver_item.driver_doc.date = moment(this.form.driver_item.driver_doc.date).format('YYYY-MM-DD')

                  this.form.owner_item = this.form.owner_item || this.select.clients.filter(a=>a.id == this.form.owner)[0] || { driver_doc: {} }
                  this.form.owner_item.driver_doc.date = moment(this.form.owner_item.driver_doc.date).format('YYYY-MM-DD')
                  this.form.insurances = this.form.insurances || []
                  for (let x in this.form.insurances) {
                    this.form.insurances[x].doc.date = moment(this.form.insurances[x].doc.date).format('YYYY-MM-DD')
                    this.form.insurances[x].doc.date_text = moment(this.form.insurances[x].doc.date).format('DD.MM.YYYY')
                  }
          }
          this.load_events()
        } else {
          this.form = {
            id: '',
            doc: {
              series: '',
              number: '',
              date: '',
            },
            vehicle: '',
            vehicle_item: { doc: {} },
            driver_item: { driver_doc: {} },
            owner_item: { driver_doc: {} },
            insurances: [],
          }
        }
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          vehicle: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                if (result.data.data[x].type > 0) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },

      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          client: this.form.driver_item.id,
          client_item: this.form.driver_item,
          vehicle: this.form.id,
          vehicle_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      vehicle_save: function () {
        let id = null
        if (this.data) id = this.data.id
        else {
          if (this.$route.params.id) id = this.$route.params.id
        }
        if (this.create) {
          this.$axios.post('/api/vehicle/create/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.show ? this.$emit('close', response.data.data) : this.$router.push('/vehicle/list')
              } else {
                this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else {
          this.form.id = id
          this.$axios.post('/api/vehicle/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.show ? this.$emit('close', response.data.data) : this.$router.push('/vehicle/list')
              } else {
                this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        }
      },
    },
  }
</script>
